export default class BelegPatient {
    /** PK: Belegpatient | erforderlich */
    public belegpatient_id: number | null = null;
    /** FK: Beleg */
    public beleg_id: number | null = null;
    /** FK: Patient */
    public patnr: number | null = null;

    public patient_titel: string | null = null;
    public patient_nachname: string | null = null;
    public patient_vorname: string | null = null;
    public patient_geburtsdatum: string | null = null;

    constructor(data?: Partial<BelegPatient>) {
        Object.assign(this, data);
    }
}
